//reset session data while click on menu link
$(document).ready(function() { 
  //reset filter values for desktop
  setTimeout(function(){    
      jQuery(".tmenu_item").click(function() {        
        localStorage.clear();
      });
  }, 1200);

  //reset filter values for mobile
  jQuery(".menu-drawer__menu").click(function() {    
    localStorage.clear();
  });
  
});